import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classes from './FilterBox.scss';

import LinearProgress from '@mui/material/LinearProgress';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined'
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';

export default class FilterBox extends Component {

  static propTypes = {
    title: PropTypes.string,
    expanded: PropTypes.bool,
    isLoading: PropTypes.bool,
    withHeader: PropTypes.bool,
    withExpander: PropTypes.bool,
  };

  static defaultProps = {
    expanded: true,
    isLoading: false,
    withHeader: true,
    withExpander: true,
  };

  state = {
    expanded: this.props.expanded
  }

  toggle = evt => {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  render() {
    const { children, title, isLoading, id, withExpander, withHeader, className } = this.props;
    return (
      <div className={className} id={id}>
        {withHeader && (
          <div className={classes.header} onClick={withExpander ? this.toggle : null}>
            {isLoading && <LinearProgress classes={{root: classes.progress}}/>}
            {title}

            {withExpander && (
              <div className={classes.header__icon}>
                {this.state.expanded ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon /> }
              </div>
            )}
          </div>
        )}
        {this.state.expanded && (
          <>
            {children}
          </>
        )}
      </div>
    );
  }

}
